import { nanoid } from 'nanoid';
import { CREATE_PERSON_BLOCK } from '../../form-block-types';
import { IQuestionAnswer } from '../form-root/contracts';
export function prefillEntityInfo(formLayout: string, firstName?: string, lastName?: string, email?: string): IQuestionAnswer[] | undefined {
	if (!formLayout) return undefined;

	const userInfo: Record<string, string> = {};
	if (firstName) userInfo.firstName = firstName;
	if (lastName) userInfo.lastName = lastName;
	if (email) userInfo.email = email;

	const layout = JSON.parse(formLayout);
	const sections = layout?.layouts?.[0]?.props?.sections ?? [];

	const prefilledAnswers = sections
		.flatMap(section => section?.fields ?? [])
		.filter(field => field.type === CREATE_PERSON_BLOCK)
		.map(field => {
			const answer = { contacts: [{ id: nanoid(), ...userInfo }] };
			return {
				questionName: field.name,
				answer: {
					answerJson: JSON.stringify(answer)
				},
				type: field.type
			};
		});

	return prefilledAnswers.length > 0 ? prefilledAnswers : undefined;
}
